/* pr-collection.js: the category page (port of the mockup/v3/shop.html script onto Liquid-rendered cards).
   The section renders every card of the page (paginate by 50) in Featured order plus a JSON blob [data-pr-grid] in the same
   order. This script only hides, reorders and reveals those cells:
     filters  Size (in stock in that size) · Colour family · Price band · Padding (bra scopes)
     sort     featured | price-asc | price-desc | new   (sold out always last)
     URL      ?size=36D,38C&colour=black&price=250-299&pad=padded&sort=price-asc   (history.replaceState)
     chips    Section Rendering API: fetch(<collection url>?section_id=<id>), swap the section, pushState; Back/Forward work.
              Any failure falls back to normal navigation.
   Show more: 12 on phones / 16 on desktop (section settings), never leaves 4 or fewer behind a button. No infinite scroll.
   Public: PR.collection = { instances, go(url), open(), close() }. Registered through PR.sections.register. */
(function (w, d) {
  'use strict';
  var PR = w.PR = w.PR || {};

  /* ---- small helpers (prefer the shell's, keep a local fallback so this file never hard-fails) ---- */
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) {
    if (PR.esc) return PR.esc(s);
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function reduced() {
    try { return PR.reduced ? PR.reduced() : w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function json(node) { if (!node) return null; try { return JSON.parse(node.textContent); } catch (e) { return null; } }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  /* size keys exactly as the mockup URL used them: 36D, S, 2XL, Free size */
  function normSize(s) { s = String(s || '').toUpperCase().trim(); return s === 'XXL' ? '2XL' : s === 'XXXL' ? '3XL' : /^FREE/.test(s) ? 'Free size' : s; }
  function closeIcon() {
    return PR.icon ? PR.icon('close') : '<svg class="pr-i" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15"/></svg>';
  }
  /* colour family for filters (same table as the mockup's AP.p.colourFamily) */
  var FAM_RX = [['Black', /black|charcoal/], ['White', /white/], ['Nude & skin', /skin|nude|beige|almond|sand|tan\b/], ['Pink', /pink|magenta|rose|blush|onion|onine|coral/],
    ['Red & wine', /red|wine|maroon|cherry|mulbery|rust/], ['Purple', /purple|lavender|lavander|plum/], ['Blue', /blue|navy|cyan|turquoise|teal/],
    ['Green', /green/], ['Grey', /grey|fog/], ['Brown', /brown|coffee|gold/]];
  function family(name) {
    var n = String(name || '').toLowerCase();
    if (n.indexOf(',') >= 0) return 'Multi';
    if (/print/.test(n)) return 'Print';
    for (var i = 0; i < FAM_RX.length; i++) if (FAM_RX[i][1].test(n)) return FAM_RX[i][0];
    return 'Other';
  }
  var FAMS = [['Black', '#1E1A1C'], ['White', '#FFFFFF'], ['Nude & skin', '#E3B9A0'], ['Pink', '#F48FB1'], ['Red & wine', '#8E2433'], ['Purple', '#9C83A8'],
    ['Blue', '#2F5DA8'], ['Green', '#4C8C4A'], ['Grey', '#9A9A9E'], ['Brown', '#6B4632'],
    ['Print', 'radial-gradient(circle at 30% 30%, rgba(255,255,255,.9) 0 1.5px, transparent 2px) 0 0/6px 6px, #2F5DA8']];
  var APPAREL = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'Free size'];
  var CUPS = ['B', 'C', 'D'];
  var FACETS = ['size', 'colour', 'price', 'pad'];
  var SORTS = ['featured', 'price-asc', 'price-desc', 'new'];
  /* price bands by the lowest price, in paise */
  var BANDS = [
    { key: 'under-250', test: function (v) { return v < 25000; } },
    { key: '250-299', test: function (v) { return v >= 25000 && v < 30000; } },
    { key: '300-399', test: function (v) { return v >= 30000 && v < 40000; } },
    { key: '400-plus', test: function (v) { return v >= 40000; } }
  ];
  var STORE = 'pr_col_v1';
  var instances = [];

  /* ======================================================================================================== */
  function init(root, opt) {
    if (!root || root.__prCol) return;
    opt = opt || {};
    var cfg = json($('script[data-pr-collection-config]', root)) || {};
    var T = cfg.t || {};
    var el = {
      chips: $('[data-sh-chips]', root), bar: $('[data-sh-bar]', root), fbtn: $('[data-sh-filter]', root), fn: $('[data-sh-filter-n]', root),
      sort: $('[data-sh-sort]', root), sortLab: $('[data-sh-sort-label]', root), res: $('[data-sh-results]', root),
      active: $('[data-sh-active]', root), grid: $('[data-sh-grid]', root), empty: $('[data-sh-empty]', root),
      more: $('[data-sh-more]', root), moreTxt: $('[data-sh-more-txt]', root), moreBar: $('[data-sh-more-bar]', root), moreBtn: $('[data-sh-more-btn]', root),
      sheet: $('[data-sh-sheet]', root), facets: $('[data-sh-facets]', root), sClear: $('[data-sh-sheet-clear]', root), sShow: $('[data-sh-sheet-show]', root)
    };
    var inst = { root: root, cfg: cfg, off: [] };
    root.__prCol = inst;
    instances.push(inst);
    function on(target, type, fn, o) { target.addEventListener(type, fn, o); inst.off.push(function () { target.removeEventListener(type, fn, o); }); }

    // chips switch in place (works even when the grid is empty)
    on(root, 'click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[data-pr-chip]'); if (!a) return;
      e.preventDefault();
      if (a.getAttribute('aria-current') === 'page') return;
      go(a.href, true);
    });
    keepChipInView(el.chips, opt.chipScroll);
    if (opt.swap) $$('[data-sh-swap]', root).forEach(function (n) { n.classList.add('sh-swap'); });

    var all = json($('script[data-pr-grid]', root)) || [];
    if (!el.grid || !all.length) return inst;
    var cells = {};
    $$('.sh-cell', el.grid).forEach(function (li) { cells[li.getAttribute('data-i')] = li; });
    all = all.filter(function (p) { p.el = cells[String(p.i)]; return !!p.el; });
    all.forEach(function (p) { p.f = facts(p); p.card = $('.ap-card', p.el); p.wide0 = p.el.classList.contains('sh-cell--wide'); });
    var LABEL = { featured: T.featured, 'price-asc': T['price-asc'], 'price-desc': T['price-desc'], 'new': T['new'] };
    var priceLabels = cfg.priceLabels || [];

    /* ---- facts per product, from the blob ---- */
    function facts(p) {
      var f = { size: {}, offered: {}, colour: {}, price: {}, pad: {}, stock: {} };
      (p.sizes || []).forEach(function (s) { f.offered[normSize(s)] = 1; });
      var st = p.in_stock || {};
      Object.keys(st).forEach(function (s) {
        var k = normSize(s), fams = {};
        f.size[k] = 1;
        (st[s] || []).forEach(function (c) { String(c).split(',').forEach(function (x) { fams[family(x.trim())] = 1; }); });
        f.stock[k] = fams;
      });
      (p.colours || []).forEach(function (c) {
        String(c).split(',').forEach(function (x) { x = x.trim(); var fm = family(x); if (x && fm !== 'Other' && fm !== 'Multi') f.colour[fm] = 1; });
      });
      BANDS.forEach(function (b) { if (b.test(p.price)) f.price[b.key] = 1; });
      if (p.category === 'bra' && p.padding) f.pad[p.padding] = 1;
      return f;
    }
    function matches(p, flt, skip) {
      var f = p.f;
      for (var i = 0; i < FACETS.length; i++) {
        var k = FACETS[i], sel = flt[k];
        if (k === skip || !sel.length) continue;
        if (!sel.some(function (v) { return f[k][v]; })) return false;
      }
      // size + colour together: that colour must be in stock in one of the chosen sizes
      if (skip !== 'size' && skip !== 'colour' && flt.size.length && flt.colour.length) {
        var ok = flt.size.some(function (s) { var fams = f.stock[s]; return fams && flt.colour.some(function (c) { return fams[c]; }); });
        if (!ok) return false;
      }
      return true;
    }
    function emptyFlt() { return { size: [], colour: [], price: [], pad: [] }; }
    function nSel(flt) { return FACETS.reduce(function (n, k) { return n + flt[k].length; }, 0); }
    function copyFlt(flt) { var o = emptyFlt(); FACETS.forEach(function (k) { o[k] = flt[k].slice(); }); return o; }

    /* ---- URL <-> filters ---- */
    var QKEY = { size: 'size', colour: 'colour', price: 'price', pad: 'pad' };
    function fromQuery(search) {
      var q = new URLSearchParams(search || ''), flt = emptyFlt();
      FACETS.forEach(function (k) {
        var v = (q.get(QKEY[k]) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        if (k === 'size') v = v.map(normSize);
        if (k === 'colour') v = v.map(function (x) { var fm = FAMS.filter(function (f) { return slug(f[0]) === slug(x); })[0]; return fm ? fm[0] : ''; }).filter(Boolean);
        flt[k] = v;
      });
      var so = q.get('sort');
      return { flt: flt, sort: SORTS.indexOf(so) >= 0 ? so : 'featured' };
    }

    /* ---- state ---- */
    var S = { flt: emptyFlt(), sort: 'featured', shown: 0, list: [] };
    inst.state = S;
    function pageSize() { return w.innerWidth >= 1069 ? (cfg.perDesktop || 16) : (cfg.perMobile || 12); }
    function fit(shown, n) { return n - shown > 0 && n - shown <= 4 ? n : Math.min(shown, n); }
    function fmtN(tpl, map) { var s = String(tpl || ''); Object.keys(map).forEach(function (k) { s = s.split(k).join(String(map[k])); }); return s; }
    function styles(n) { return n === 1 ? T.styles1 : fmtN(T.stylesN, { 7777: n }); }
    function isAllBras() { return all.length > 1 && all.every(function (p) { return p.category === 'bra'; }); }
    function scopeHasPadding() {
      if (cfg.showPadding === false || !isAllBras()) return false;
      if (cfg.handle === 'padded-bras' || cfg.handle === 'non-padded-bras') return false;
      return has('pad', 'padded') || has('pad', 'non-padded');
    }
    function has(key, v) { return all.some(function (p) { return p.f[key][v]; }); }
    function options(k) {
      if (k === 'size') {
        var bras = [], app = [];
        CUPS.forEach(function (c) {
          var row = [];
          for (var b = 28; b <= 46; b += 2) if (has('offered', b + c)) row.push(b + c);
          if (row.length) bras.push({ cup: c, vals: row });
        });
        APPAREL.forEach(function (s) { if (has('offered', s)) app.push(s); });
        return { bras: bras, app: app };
      }
      if (k === 'colour') return FAMS.filter(function (f) { return has('colour', f[0]); });
      if (k === 'price') return BANDS.filter(function (b) { return has('price', b.key); });
      if (k === 'pad') return scopeHasPadding() ? [['padded', T.padded], ['non-padded', T['non-padded']]] : [];
      return [];
    }
    function allValues(k) {
      var o = options(k);
      if (k === 'size') return o.bras.reduce(function (a, r) { return a.concat(r.vals); }, []).concat(o.app);
      if (k === 'colour') return o.map(function (f) { return f[0]; });
      if (k === 'price') return o.map(function (b) { return b.key; });
      return o.map(function (x) { return x[0]; });
    }
    /* a chip switch can land on a category that doesn't offer a value: drop it */
    function prune() { FACETS.forEach(function (k) { var ok = allValues(k); S.flt[k] = S.flt[k].filter(function (v) { return ok.indexOf(v) >= 0; }); }); }
    function count(k, v) { var t = copyFlt(S.flt); t[k] = [v]; return all.filter(function (p) { return matches(p, t); }).length; }
    function bandLabel(key) { for (var i = 0; i < BANDS.length; i++) if (BANDS[i].key === key) return priceLabels[i] || key; return key; }
    function label(k, v) {
      if (k === 'price') return bandLabel(v);
      if (k === 'pad') return v === 'padded' ? T.padded : T['non-padded'];
      return v;
    }
    function feat(p) { return p.best >= 0 ? p.best : p.new ? 100 : 200; }
    function results() {
      var cmp = {
        'price-asc': function (a, b) { return a.price - b.price || a.idx - b.idx; },
        'price-desc': function (a, b) { return b.price - a.price || a.idx - b.idx; },
        'new': function (a, b) { return (b.new - a.new) || (b.published - a.published) || feat(a) - feat(b) || a.idx - b.idx; },
        featured: function (a, b) { return feat(a) - feat(b) || a.idx - b.idx; }
      }[S.sort] || null;
      var so = function (p) { return p.available ? 0 : 1; };
      return all.filter(function (p) { return matches(p, S.flt); }).sort(function (a, b) { return so(a) - so(b) || cmp(a, b) || a.i - b.i; });
    }
    function nNew() { return all.filter(function (p) { return p.new; }).length; }

    /* ---- URL ---- */
    function query() {
      var parts = [];
      new URLSearchParams(w.location.search).forEach(function (v, k) {
        if (k === 'sort' || k === 'section_id' || FACETS.some(function (f) { return QKEY[f] === k; })) return;
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
      FACETS.forEach(function (k) {
        if (S.flt[k].length) parts.push(QKEY[k] + '=' + S.flt[k].map(function (v) { return encodeURIComponent(k === 'colour' ? slug(v) : v); }).join(','));
      });
      if (S.sort !== 'featured') parts.push('sort=' + S.sort);
      return parts.length ? '?' + parts.join('&') : '';
    }
    inst.query = query;
    function syncUrl() { try { w.history.replaceState({ prCol: 1 }, '', w.location.pathname + query() + w.location.hash); } catch (e) {} }

    /* ---- persistence: "shown" + scroll for Back from a product (try/catch: private windows can throw) ---- */
    function key() { return w.location.pathname + query(); }
    function readAll() { try { return JSON.parse(w.sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
    function save() {
      try {
        var a = readAll(); a[key()] = { shown: S.shown, y: Math.round(w.scrollY || 0), ts: Date.now() };
        w.sessionStorage.setItem(STORE, JSON.stringify(a));
      } catch (e) {}
    }
    function load() { var s = readAll()[key()]; return s && Date.now() - (s.ts || 0) < 6 * 3600e3 ? s : null; }

    /* ---- render ---- */
    function renderBar() {
      if (!el.bar) return;
      var n = nSel(S.flt), k = S.list.length;
      el.fn.hidden = !n; el.fn.textContent = n;
      el.fbtn.classList.toggle('is-on', !!n);
      el.fbtn.setAttribute('aria-label', (T.filter || 'Filter') + (n ? ', ' + n : ''));
      // "New" only where it changes the order (some styles new, some not)
      var nn = nNew(), newOpt = el.sort.querySelector('option[value="new"]');
      if (newOpt) { newOpt.hidden = newOpt.disabled = !nn || nn === all.length; if (newOpt.disabled && S.sort === 'new') S.sort = 'featured'; }
      el.sort.value = S.sort; el.sortLab.textContent = LABEL[S.sort] || '';
      // the count is in the hero; the toolbar only speaks up once filters narrow it
      el.res.textContent = n ? fmtN(T.showing, { 7771: k, 7772: all.length }) : '';
    }
    function renderPills() {
      if (!el.active) return;
      var html = '';
      FACETS.forEach(function (k) {
        S.flt[k].forEach(function (v) {
          var sw = k === 'colour' ? (FAMS.filter(function (f) { return f[0] === v; })[0] || [])[1] : '';
          html += '<button type="button" class="sh-pill" data-rm="' + k + '" data-val="' + esc(v) + '" aria-label="' + esc((T.remove || 'Remove') + ': ' + label(k, v)) + '">' +
            (sw ? '<i style="--sw:' + esc(sw) + '"></i>' : '') + esc(label(k, v)) + closeIcon() + '</button>';
        });
      });
      el.active.innerHTML = html ? html + '<button type="button" class="sh-clear" data-sh-clear>' + esc(T.clearAll) + '</button>' : '';
      el.active.hidden = !html;
    }
    function renderMore() {
      var n = S.list.length, shown = fit(S.shown, n), left = n - shown;
      el.more.hidden = left <= 0 && shown <= pageSize() + 4;   // the progress line stays only after she pressed Show more
      el.moreTxt.textContent = fmtN(T.showing, { 7771: shown, 7772: n });
      el.moreBar.style.setProperty('--f', n ? (shown / n).toFixed(3) : 0);
      el.moreBtn.hidden = left <= 0;
      el.moreBtn.textContent = fmtN(T.showMore, { 7777: left });
    }
    function renderEmpty() { el.empty.hidden = !!S.list.length; }
    function place(fadeIn) {
      var list = S.list, n = list.length, shown = fit(Math.max(S.shown, 1), n), want = [];
      S.shown = Math.max(S.shown, shown);
      all.forEach(function (p) { p._on = false; });
      list.forEach(function (p) { p._on = true; want.push(p.el); });
      all.forEach(function (p) { if (!p._on) want.push(p.el); });
      var kids = el.grid.children, same = kids.length === want.length;
      for (var i = 0; same && i < want.length; i++) if (kids[i] !== want[i]) same = false;
      if (!same) want.forEach(function (li) { el.grid.appendChild(li); });
      list.forEach(function (p, k) { p.el.hidden = k >= shown; });
      all.forEach(function (p) {
        if (!p._on) p.el.hidden = true;
        var wide = n === 1 ? p === list[0] : p.wide0;
        p.el.classList.toggle('sh-cell--wide', wide);
        if (p.card) p.card.classList.toggle('ap-card--wide', wide);
        if (fadeIn) p.el.classList.remove('sh-in');
      });
      el.grid.classList.add('is-live');
      el.grid.classList.remove('is-out');
    }
    function renderGrid(fade) {
      S.list = results();
      if (fade && !reduced() && el.grid.classList.contains('is-live')) {
        el.grid.classList.add('is-out');
        setTimeout(function () { place(true); }, 120);
      } else place(false);
      renderMore(); renderEmpty(); renderBar(); renderPills();
    }

    /* ---- filter sheet (no per-option counts: an option that would leave nothing is disabled;
           the live "Show N results" button carries the one number) ---- */
    function optBtn(k, v, text, extra) {
      var onv = S.flt[k].indexOf(v) >= 0, n = count(k, v);
      return '<button type="button" class="sh-opt" data-facet="' + k + '" data-val="' + esc(v) + '" aria-pressed="' + onv + '"' +
        (!n && !onv ? ' disabled aria-label="' + esc(text + ', ' + (T.unavailable || '')) + '"' : '') + '>' + (extra || '') + '<span>' + esc(text) + '</span></button>';
    }
    function renderFacets() {
      if (!el.facets) return;
      var html = '', o = options('size');
      if (o.bras.length || o.app.length) {
        var anyBra = all.some(function (p) { return p.category === 'bra'; });
        var nonBra = all.filter(function (p) { return p.category !== 'bra'; });
        var braSizes = o.bras.reduce(function (a, r) { return a.concat(r.vals); }, []).join(',');
        var guide = anyBra
          ? '<button type="button" class="ap-quiet-link sh-facet__hint" data-ap-size-open data-tab="chart"' + (braSizes ? ' data-sizes="' + esc(braSizes) + '"' : '') + '>' + esc(T.sizeGuide) + '</button>'
          : cfg.sizeGuide ? '<a class="ap-quiet-link sh-facet__hint" href="' + esc(cfg.sizeGuide) + '">' + esc(T.sizeGuide) + '</a>' : '';
        html += '<section class="sh-facet"><h3 class="sh-facet__t">' + esc(T.size) + ' ' + guide + '</h3><p class="sh-facet__sub">' + esc(T.inStockSize) + '</p>';
        var appLabel = nonBra.length && nonBra.every(function (p) { return p.category === 'panty'; }) ? cfg.pantyLabel : cfg.apparelLabel;
        var braRows = function () {
          o.bras.forEach(function (r) {
            html += '<p class="sh-facet__sub">' + esc(String(cfg.cupLabel || '[cup]').replace('[cup]', r.cup)) + '</p><div class="sh-opts sh-opts--size">' +
              r.vals.map(function (v) { return optBtn('size', v, v); }).join('') + '</div>';
          });
        };
        var appRow = function () {
          if (o.app.length) html += (o.bras.length ? '<p class="sh-facet__sub">' + esc(appLabel || '') + '</p>' : '') +
            '<div class="sh-opts sh-opts--size">' + o.app.map(function (v) { return optBtn('size', v, v); }).join('') + '</div>';
        };
        if (anyBra) { braRows(); appRow(); } else { appRow(); braRows(); }
        html += '</section>';
      }
      o = options('colour');
      if (o.length) html += '<section class="sh-facet"><h3 class="sh-facet__t">' + esc(T.colour) + '</h3><div class="sh-opts sh-opts--2">' +
        o.map(function (f) { return optBtn('colour', f[0], f[0], '<i class="sh-opt__sw" style="--sw:' + esc(f[1]) + '"></i>'); }).join('') + '</div></section>';
      o = options('price');
      if (o.length > 1) html += '<section class="sh-facet"><h3 class="sh-facet__t">' + esc(T.price) + '</h3><div class="sh-opts sh-opts--2">' +
        o.map(function (b) { return optBtn('price', b.key, bandLabel(b.key)); }).join('') + '</div></section>';
      o = options('pad');
      if (o.length) html += '<section class="sh-facet"><h3 class="sh-facet__t">' + esc(T.padding) + '</h3><div class="sh-opts sh-opts--2">' +
        o.map(function (x) { return optBtn('pad', x[0], x[1]); }).join('') + '</div></section>';
      var top = el.facets.scrollTop;
      el.facets.innerHTML = html;
      el.facets.scrollTop = top;
      var k = S.list.length;
      el.sShow.textContent = k === 1 ? T.show1 : fmtN(T.showN, { 7777: k });
      el.sClear.disabled = !nSel(S.flt);
    }
    function openSheet() {
      if (!el.sheet) return;
      renderFacets();
      el.sheet.classList.remove('is-closing');
      if (el.sheet.showModal) { if (!el.sheet.open) el.sheet.showModal(); } else el.sheet.setAttribute('open', '');
      d.body.classList.add('ap-lock');
      el.facets.scrollTop = 0;
    }
    function closeSheet(now) {
      if (!el.sheet || !el.sheet.open) return;
      var done = function () {
        el.sheet.classList.remove('is-closing');
        if (el.sheet.close) el.sheet.close(); else el.sheet.removeAttribute('open');
        d.body.classList.remove('ap-lock');
        if (!now && el.fbtn) el.fbtn.focus({ preventScroll: true });
      };
      if (now || reduced()) return done();
      el.sheet.classList.add('is-closing'); setTimeout(done, 250);
    }
    inst.open = openSheet; inst.close = closeSheet;

    function gridTop() {
      var anchor = el.chips || el.bar || el.grid;
      return anchor.getBoundingClientRect().top + w.scrollY - (el.bar ? parseFloat(getComputedStyle(el.bar).top) || 44 : 44) - 8;
    }
    function settleScroll() { var y = gridTop(); if (w.scrollY > y) w.scrollTo(0, y); }
    inst.settle = settleScroll;
    function changed() { S.shown = pageSize(); renderGrid(false); settleScroll(); if (el.sheet && el.sheet.open) renderFacets(); syncUrl(); }
    function toggle(k, v) { var a = S.flt[k], i = a.indexOf(v); if (i >= 0) a.splice(i, 1); else a.push(v); changed(); }
    function clearAll() { S.flt = emptyFlt(); changed(); }

    /* ---- wire ---- */
    if (el.fbtn) on(el.fbtn, 'click', openSheet);
    if (el.sheet) {
      on(el.sheet, 'click', function (e) {
        if (e.target === el.sheet || e.target.closest('[data-sh-close]')) { closeSheet(); return; }
        var b = e.target.closest('.sh-opt'); if (!b || b.disabled) return;
        var k = b.getAttribute('data-facet'), v = b.getAttribute('data-val');
        toggle(k, v);
        var again = el.facets.querySelector('.sh-opt[data-facet="' + k + '"][data-val="' + (w.CSS && CSS.escape ? CSS.escape(v) : v) + '"]');
        if (again) again.focus({ preventScroll: true });
      });
      on(el.sheet, 'cancel', function (e) { e.preventDefault(); closeSheet(); });
      on(el.sClear, 'click', function () { clearAll(); var f = el.facets.querySelector('.sh-opt'); if (f) f.focus({ preventScroll: true }); });
    }
    if (el.sort) on(el.sort, 'change', function () { S.sort = el.sort.value; changed(); });
    on(el.moreBtn, 'click', function () {
      var kb = el.moreBtn.matches(':focus-visible'), start = Math.min(S.shown, S.list.length);
      S.shown = fit(start + pageSize(), S.list.length);
      var added = S.list.slice(start, S.shown);
      added.forEach(function (p, i) {
        p.el.hidden = false;
        if (!reduced()) { p.el.classList.remove('sh-in'); void p.el.offsetWidth; p.el.classList.add('sh-in'); p.el.style.setProperty('--i', i % 8); }
      });
      if (PR.refresh) PR.refresh(el.grid);
      renderMore();
      var first = added[0] && $('a', added[0].el);
      if (first && (kb || el.moreBtn.hidden)) first.focus({ preventScroll: true });   // keyboard: land on the first new card
      save();
    });
    on(root, 'click', function (e) {
      var rm = e.target.closest('[data-rm]');
      if (rm) { toggle(rm.getAttribute('data-rm'), rm.getAttribute('data-val')); var nx = $('.sh-pill', el.active) || el.fbtn; if (nx) nx.focus({ preventScroll: true }); return; }
      if (e.target.closest('[data-sh-clear]')) { clearAll(); if (el.fbtn) el.fbtn.focus({ preventScroll: true }); return; }
      if (e.target.closest('a.ap-card')) save();
    });
    on(w, 'pagehide', save);
    // toolbar hairline once it sticks
    var tick = false;
    function stuck() {
      tick = false; if (!el.bar) return;
      var top = parseFloat(getComputedStyle(el.bar).top) || 0;
      el.bar.classList.toggle('is-stuck', w.scrollY > 0 && el.bar.getBoundingClientRect().top <= top + 0.5);
    }
    on(w, 'scroll', function () { if (!tick) { tick = true; w.requestAnimationFrame(stuck); } }, { passive: true });

    /* re-read filters from the URL (Back/Forward inside the same collection) */
    inst.reread = function () { var q = fromQuery(w.location.search); S.flt = q.flt; S.sort = q.sort; prune(); S.shown = pageSize(); renderGrid(true); };

    /* ---- first render ---- */
    var q = fromQuery(w.location.search);
    S.flt = q.flt; S.sort = q.sort; prune();
    var navType = '';
    try { var ne = w.performance.getEntriesByType('navigation')[0]; navType = ne ? ne.type : ''; } catch (e) {}
    var saved = !opt.swap && (navType === 'back_forward' || navType === 'reload') ? load() : null;
    S.shown = saved && saved.shown > 0 ? saved.shown : pageSize();
    renderGrid(false);
    syncUrl();
    if (saved && saved.y) {
      var y = saved.y, tries = 0;
      (function to() { w.scrollTo(0, y); if (Math.abs(w.scrollY - y) > 2 && tries++ < 10) w.requestAnimationFrame(to); })();
    }
    stuck();
    return inst;
  }

  function destroy(root) {
    var inst = root && root.__prCol; if (!inst) return;
    try { if (inst.close) inst.close(true); } catch (e) {}
    inst.off.forEach(function (f) { try { f(); } catch (e) {} });
    root.__prCol = null;
    var i = instances.indexOf(inst); if (i >= 0) instances.splice(i, 1);
  }

  /* the active chip stays in view (sideways only; the page doesn't move) */
  function keepChipInView(wrap, x) {
    if (!wrap) return;
    if (x) wrap.scrollLeft = x;
    var onChip = $('.ap-chip[aria-current]', wrap);
    if (!onChip || wrap.scrollWidth <= wrap.clientWidth) return;
    var sr = wrap.getBoundingClientRect(), or = onChip.getBoundingClientRect(), gut = parseFloat(getComputedStyle(wrap).scrollPaddingLeft) || 20;
    if (or.left < sr.left + gut - 1 || or.right > sr.right - 40) wrap.scrollLeft = Math.max(0, or.left - sr.left + wrap.scrollLeft - gut);
  }

  /* head tags follow a chip swap: title, canonical, description, og:url/og:title */
  function seo(c) {
    function set(sel, attr, v) { var m = d.head.querySelector(sel); if (m && v) m.setAttribute(attr, v); }
    if (c.docTitle) d.title = c.docTitle;
    var abs = '';
    try { abs = c.canonical ? new URL(c.canonical, w.location.href).href : ''; } catch (e) {}
    set('link[rel="canonical"]', 'href', abs);
    set('meta[property="og:url"]', 'content', abs);
    set('meta[name="description"]', 'content', c.description);
    set('meta[property="og:description"]', 'content', c.description);
    set('meta[name="twitter:description"]', 'content', c.description);
    if (c.docTitle) { set('meta[property="og:title"]', 'content', c.docTitle.split(' – ')[0]); set('meta[name="twitter:title"]', 'content', c.docTitle.split(' – ')[0]); }
  }

  /* ---- chip switch: Section Rendering API, then swap the section in place ---- */
  var busy = null;
  function current() { return instances.filter(function (x) { return d.documentElement.contains(x.root); })[0] || null; }
  function go(href, push) {
    var inst = current(), u;
    try { u = new URL(href, w.location.href); } catch (e) { return; }
    var qs = push ? (inst && inst.query ? inst.query() : '') : u.search;
    var target = u.pathname + qs + u.hash;
    if (!inst || !w.fetch || !w.DOMParser) { w.location.href = target; return; }
    var root = inst.root, sid = inst.cfg.sectionId || root.getAttribute('data-section-id');
    if (busy) busy.abort && busy.abort();
    busy = w.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');
    w.fetch(u.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin', signal: busy ? busy.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-pr-section="pr-collection"]');
        if (!next) throw new Error('no section');
        next = d.importNode(next, true);
        var sc = $('[data-sh-chips]', root), x = sc ? sc.scrollLeft : 0;
        if (push) { try { w.history.pushState({ prCol: 1 }, '', target); } catch (e) {} }
        destroy(root);
        root.parentNode.replaceChild(next, root);
        var ni = init(next, { swap: true, chipScroll: x });
        if (PR.refresh) { try { PR.refresh(next); } catch (e) {} }
        if (ni && ni.cfg) seo(ni.cfg);
        if (ni && ni.settle) ni.settle();
        try { d.dispatchEvent(new CustomEvent('pr:collection', { detail: { handle: ni && ni.cfg.handle, url: target } })); } catch (e) {}
        busy = null;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        busy = null;
        if (push) w.location.href = target; else w.location.reload();
      });
  }

  w.addEventListener('popstate', function (e) {
    var inst = current(); if (!inst || !(e.state && e.state.prCol)) return;
    var path = '';
    try { path = new URL(inst.cfg.url || '', w.location.href).pathname; } catch (er) {}
    if (path && path === w.location.pathname) { if (inst.reread) inst.reread(); }
    else go(w.location.href, false);
  });

  PR.collection = {
    instances: instances,
    go: function (url) { go(url, true); },
    open: function () { var i = current(); if (i && i.open) i.open(); },
    close: function () { var i = current(); if (i && i.close) i.close(); }
  };

  try { if ('scrollRestoration' in w.history) w.history.scrollRestoration = 'manual'; } catch (e) {}
  if (PR.sections && PR.sections.register) PR.sections.register('pr-collection', function (el) { init(el); }, destroy);
  else {
    var boot = function () { $$('[data-pr-section="pr-collection"]').forEach(function (el) { init(el); }); };
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  }
})(window, document);